export default "__VITE_ASSET__ee417195__"